import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, FileText, Download, Smartphone, Printer, Zap, Infinity as InfinityIcon } from 'lucide-react';
export function Hero() {
  return <section className="bg-[#FAF7F2] text-[#1F3A5F] py-12 md:py-20 overflow-hidden" data-id="element-105">
      <div className="container mx-auto px-4 max-w-5xl flex flex-col items-center" data-id="element-106">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="md:text-5xl lg:text-6xl text-center mb-4 uppercase font-oswald tracking-wide text-[26px] sm:text-[30px] font-[900] leading-[1.05]" data-id="element-107">
          MANUAL ACADÉMICO LENGUA Y LITERATURA PARA DOCENTES
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="mb-12" data-id="element-108">
          <span className="bg-[#2D6A4F] text-white px-6 py-2 rounded-full md:text-base font-semibold tracking-wider flex gap-2 shadow-md flex-col items-center justify-center text-[14px] pt-[1px] pb-[1px]" data-id="element-109">
            PARA DOCENTES DE NIVEL SECUNDARIO
          </span>
        </motion.div>

        {/* Book Mockup */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="w-full max-w-xl md:max-w-3xl mx-auto flex items-center justify-center mb-12" data-id="element-110">
          <img src="https://cdn.magicpatterns.com/uploads/jKGaFugKjfK8sxZKFpwUT6/mockup_lengua_y_literatura.png" alt="Manual Académico de Lengua y Literatura para Docentes" className="w-full h-auto" data-id="element-111" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-xl md:text-3xl font-semibold text-center mb-6 max-w-3xl" data-id="element-112">
          El sistema definitivo para docentes de LENGUA Y LITERATURA sin perder
          horas preparando material.
        </motion.h2>

        {/* Format Tags */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.35
      }} className="flex flex-wrap justify-center gap-2 md:gap-3 mb-10 max-w-3xl" data-id="element-113">
          {[{
          icon: FileText,
          label: 'Formato PDF'
        }, {
          icon: Zap,
          label: 'Acceso inmediato'
        }, {
          icon: Smartphone,
          label: 'Celular, tablet o PC'
        }, {
          icon: Download,
          label: 'Descarga digital'
        }, {
          icon: Printer,
          label: 'Imprimible'
        }, {
          icon: InfinityIcon,
          label: 'Acceso de por vida'
        }].map(({
          icon: Icon,
          label
        }, idx) => <span key={idx} className="inline-flex items-center gap-1.5 bg-white border border-[#1F3A5F]/15 text-[#1F3A5F] px-3 py-1.5 rounded-full text-xs md:text-sm font-semibold shadow-sm" data-id="element-114">
              <Icon size={14} className="text-[#2D6A4F]" data-id="element-115" />
              {label}
            </span>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="bg-white rounded-xl p-8 md:p-10 mb-10 shadow-lg border border-gray-100 w-full max-w-2xl" data-id="element-116">
          <h3 className="text-2xl md:text-3xl font-bold mb-6 text-center font-oswald text-[#1F3A5F]" data-id="element-117">
            ¿Te imaginás entrar al aula con TODO listo?
          </h3>
          <p className="text-lg mb-6 text-center text-gray-600" data-id="element-118">
            Sin pasar noches:
          </p>
          <ul className="space-y-4 text-lg max-w-md mx-auto mb-8" data-id="element-119">
            {['armando clases', 'escribiendo en el pizarrón', 'buscando actividades', 'creando evaluaciones', 'improvisando explicaciones', 'organizando contenidos'].map((item, idx) => <li key={idx} className="flex items-center gap-3" data-id="element-120">
                <CheckCircle2 className="text-[#2D6A4F] flex-shrink-0" size={20} data-id="element-121" />
                <span className="text-gray-700" data-id="element-122">{item}</span>
              </li>)}
          </ul>
          <div className="text-center pt-6 border-t border-gray-100" data-id="element-123">
            <p className="text-xl md:text-2xl font-bold text-[#1F3A5F] font-playfair italic" data-id="element-124">
              Porque eso ya está hecho.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}